import
  React
from 'react';

export default ({
  size = '49'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 39 49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#990000"
      d="M0 7.64706C0 3.4237 3.42371 0 7.64706 0H29.2444C32.3033 3.44118 34.7941 6.11769 39 10.3235V41.2941C39 45.5175 35.5763 48.9412 31.3529 48.9412H7.64706C3.4237 48.9412 0 45.5175 0 41.2941V7.64706Z"
    />
    <path
      fill="#E60000"
      d="M32.9089 10.6175C30.4863 10.7145 28.535 8.6512 28.7671 6.23777L29.3494 0.183484L38.9862 10.374L32.9089 10.6175Z"
    />
    <path
      fill="#E60000"
      d="M14.4487 21.1346H11.7886V28.4706H10.3179V21.1346H7.68115V19.9393H14.4487V21.1346ZM17.1382 28.4706H15.6616V19.9393H17.1382V28.4706ZM23.8765 24.8553H20.4429V28.4706H18.9604V19.9393H24.3804V21.1346H20.4429V23.6718H23.8765V24.8553ZM30.4741 24.8553H27.0405V28.4706H25.5581V19.9393H30.978V21.1346H27.0405V23.6718H30.4741V24.8553Z"
    />
  </svg>
);
